import {pushEdapEvent} from '../../utils/edap';

const ACTIONLOCATION = 'destination-breadcrumb';

export function breadcrumbClickHandler(breadcrumbs) {
    return (event, crumb) => {
        const isHome = breadcrumbs.indexOf(crumb) === 0;

        const eventlbsuuid = isHome ? '-1' : crumb.lbsId;

        const edapData = {
            actionlocation: ACTIONLOCATION,
            eventlbsuuid,
        };

        const eventrefinements = crumb.types.join(',');

        if (eventrefinements.length > 0) {
            edapData.eventrefinements = eventrefinements;
        }

        pushEdapEvent('destination.link.click', edapData);

        pushEdapEvent('content_tile.selected', {
            action_location: ACTIONLOCATION,
            event_refinements: eventrefinements,
            event_lbsuuid: eventlbsuuid,
        });
    };
}

export default breadcrumbClickHandler;
